export const CTA_KEYS = {
  addToBag: 'Add To Bag',
  loading: 'Loading',
  notifyMe: 'Notify Me',
  waitlisted: 'Waitlisted',
  comingSoon: 'Coming Soon',
}

export const PDP__WARN_SELECT_OPTION_SOLD_OUT = {
  key: 'PDP__WARN_SELECT_OPTION_SOLD_OUT',
  text: 'Please select the size to notify you when it’s back in stock',
}

export const PDP__WARN_SELECT_OPTION_IN_STOCK = {
  key: 'PDP__WARN_SELECT_OPTION_IN_STOCK',
  text: 'Please select the size',
}

export const PDP__WARN_SELECT_OPTION_COMING_SOON = {
  key: 'PDP__WARN_SELECT_OPTION_COMING_SOON',
  text: 'Please select the size',
}
